import React from "react"
import styles from "./accordion-item.module.scss"

const AccordionItem = () => {
 return <div>AccordionItem</div>
}

export default AccordionItem